import { render, staticRenderFns } from "./SBSTablesWidget.vue?vue&type=template&id=b97143ee&scoped=true"
import script from "./SBSTablesWidget.vue?vue&type=script&lang=js"
export * from "./SBSTablesWidget.vue?vue&type=script&lang=js"
import style0 from "./SBSTablesWidget.vue?vue&type=style&index=0&id=b97143ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97143ee",
  null
  
)

export default component.exports